<div
  class="text-uppercase text-wrap p-2 rounded-1"
  [ngStyle]="{
    background: getStateColor(),
    'font-size': '9px'
  }">
  {{ config.name }}
</div>
